import React from 'react';

const CompactComicHeroSection = () => {

  return (
    /* Reducido a min-h-[30vh] y py-6 para ocupar la mitad de espacio vertical */
    <section className="relative w-full h-auto my-2 flex items-center justify-center bg-yellow-400 overflow-hidden px-4 py-2 select-none border-y-8 border-black">
      {/* Textura de puntos cómic */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'radial-gradient(circle, #000 20%, transparent 20%)',
          backgroundSize: '12px 12px'
        }}
      ></div>

      {/* Slashes laterales adaptados a la nueva altura */}
      <div className="absolute top-0 -left-10 w-24 h-full bg-red-600 transform -skew-x-12 opacity-90 border-r-4 border-black hidden md:block"></div>
      <div className="absolute top-0 -right-10 w-32 h-full bg-blue-700 transform -skew-x-12 opacity-90 border-l-4 border-black hidden md:block"></div>

      {/* Contenedor Principal */}
      <div className=" z-10 max-w-5xl mx-auto text-center transform -rotate-1 w-full">
        
        {/* Caja de impacto reducida en padding interno (p-4 md:p-6) */}
        <div className="inline-block w-full sm:w-auto bg-red-600 border-4 md:border-6 border-black p-2 md:p-4 shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] uppercase transform skew-x-[-4deg]">
          
          {/* Tipografía ajustada ligeramente en móviles para evitar desbordes por la menor altura */}
          <h1 className="font-extrabold tracking-wider text-white text-3xl sm:text-5xl md:text-7xl leading-none font-avengers">
                        
            <span className="block text-yellow-300 text-2xl sm:text-4xl md:text-5xl my-1 italic drop-shadow-[2px_2px_0px_rgba(0,0,0,1)]">
              lleva tus habilidades
            </span>
            
            <span className="block text-4xl sm:text-6xl md:text-8xl tracking-wide uppercase text-blue-100 drop-shadow-[5px_5px_0px_rgba(0,0,0,1)] border-t-4 border-black pt-1 mt-1 transform scale-102">
              ¡hasta la luna!
            </span>
          </h1>

        </div>

        

      </div>
      {/* Bocadillo de diálogo reposicionado */}
      <div className="absolute bottom-1 right-0 z-30 bg-white text-black px-4 py-1 border-2 border-black rotate-3 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] text-sm md:text-base tracking-widest font-comic">
          ¡Boom! 🚀
      </div>
      
    </section>
  );
};

export default CompactComicHeroSection;
